import { render, staticRenderFns } from "./Highlight.vue?vue&type=template&id=03dbdb17&scoped=true&lang=pug"
import script from "./Highlight.vue?vue&type=script&lang=ts"
export * from "./Highlight.vue?vue&type=script&lang=ts"
import style0 from "./Highlight.vue?vue&type=style&index=0&id=03dbdb17&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dbdb17",
  null
  
)

export default component.exports